import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconResumeSvg } from "./IconResumeSvg.mjs";
const IconResume = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconResumeSvg, ...svgProps }) });
export {
  IconResume
};
